type EnvConfig = {
  KORINT_API_URL: string;
  COGNITO_USER_POOL_ID: string;
  COGNITO_USER_POOL_WEB_CLIENT_ID: string;
  STRIPE_PUBLISHABLE_KEY: string;
  TENANT_ID: string;
  PUBLIC_POSTHOG_KEY: string;
  COGNITO_DOMAIN: string;
  DEFAULT_BROKERAGE_FIRM_ID?: string;
  FEDERATED_LOGIN_START_PATH?: string;
  FEDERATED_LOGIN_PORTAL_URL?: string;
};

export const config: EnvConfig = {
  KORINT_API_URL: import.meta.env.VITE_KORINT_API_URL,
  COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  COGNITO_USER_POOL_WEB_CLIENT_ID: import.meta.env.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID,
  TENANT_ID: import.meta.env.VITE_TENANT_ID,
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  PUBLIC_POSTHOG_KEY: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  COGNITO_DOMAIN: import.meta.env.VITE_COGNITO_DOMAIN,
  DEFAULT_BROKERAGE_FIRM_ID: import.meta.env.VITE_DEFAULT_BROKERAGE_FIRM_ID,
  FEDERATED_LOGIN_START_PATH: import.meta.env.VITE_FEDERATED_LOGIN_START_PATH,
  FEDERATED_LOGIN_PORTAL_URL: import.meta.env.VITE_FEDERATED_LOGIN_PORTAL_URL,
};
